import type React from 'react';

/**
 * Stop a badge/label click from also triggering the surrounding card/row
 * handler (e.g. an action card opening its slideout) — the click's intent is
 * the navigation, not the outer surface. Hoisted for reference stability.
 */
export function stopClickPropagation(event: React.MouseEvent): void {
  event.stopPropagation();
}
